<template>
  <div :class="classes">
    <div class="vi-sidebar--left" >
      <el-scrollbar style="height:100%;">
        <div style="height: 16px;"></div>
        <div v-for="(item,$index) in resList" :key="$index">
          <m-sidebar-parent-item :item="item"/>
        </div>
      </el-scrollbar>
    </div>
    <div class="vi-sidebar--right">
      <div class="vi-sidebar--right__title">
        <strong>{{reModule}}</strong>
      </div>
      <div class="vi-sidebar--right__sub">
        <el-scrollbar style="height:100%;">
          <div style="padding: 16px 0;">
            <div v-for="(item,$index) in children" :key="$index">
              <m-sidebar-sublevel-item :item="item" v-if="isShow(item)"/>
              <m-sidebar-sub-item :item="item" v-else/>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
  import MC from '@/module/MC'
  import { mapState } from 'vuex'
  import mSidebarSubItem from './sidebarSubItem'
  import mSidebarParentItem from './sidebarParentItem'
  import mSidebarSublevelItem from './sidebarSublevelItem'
  import { ignoreRePath, appResList, ignoreRePathExp } from './utils'

  const prefixCls = 'vi-sidebar'
  export default {
    name: 'vi-sidebar',
    data () {
      return {
      }
    },
    props: {},
    methods: {},
    watch: {},
    beforeCreate () {
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    },
    computed: {
      ...mapState('common', ['currentMenuData']),
      children () {
        if (_.isEmpty(this.currentMenuData) || _.isEmpty(this.currentMenuData.children)) {
          return []
        } else {
          return this.currentMenuData.children
        }
      },
      reModule () {
        if (_.isEmpty(this.currentMenuData) || _.isEmpty(this.currentMenuData.reModule)) {
          return ''
        } else {
          return this.currentMenuData.reModule
        }
      },
      isShow () {
        return ({ children, reUrl }) => {
          const t = _.pull(_.map(children, 'rePath'), ...ignoreRePath)
            .filter(path => !ignoreRePathExp.test(path))
          if (reUrl === '/marketing/activity' || reUrl === '/plan/home' || reUrl === '/scenes/home') {
            return false
          }
          return !_.isEmpty(t)
        }
      },
      resList () {
        const { userInfo: { resList } } = MC.config
        // resList 后台来的数据
        // 后台来的数据 本地的数据
        return [...resList, ...appResList]
      },
      classes () {
        return [
          `${prefixCls}`
        ]
      }
    },
    components: { mSidebarParentItem, mSidebarSublevelItem, mSidebarSubItem }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  $-prefix-cls: "vi-sidebar";
  $h : calc(100vh - 63px);

  .#{$-prefix-cls} {
    overflow: hidden;
    height: $h;
    &--left {
      width: 106px;
      float: left;
      background-color: #383E49;
      height: $h;
    }
    &--right {
      width: 149px;
      float: left;
      background: #fff;
      height: $h;
      &__title {
        height: 58px;
        line-height: 30px;
        padding-left: 16px;
        border-bottom: 1px solid #ddd;
        padding-top: 15px;
        strong {
          font-size: 18px;
          color: #303030;
          font-weight: bold;
        }
      }
      &__sub {
        height: calc(100vh - 120px);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/sidebar.vue